// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, styled, TextField, Typography } from "@mui/material";
// import { appendIfNotNull, CurrencyJSON, InvoiceStatus } from "../../../common/const";
// import { showNotification } from "../../../common/Notification/ToastifyNotification";
// import { apiRequest } from "../../../common/common";
// import DataTable from "../../../common/DataTable";
// import { Add, Close, DeleteOutline, EditOutlined, Upload } from "@mui/icons-material";
// import { InvoiceColumnDefs } from "./columnDefs";
// import moment from "moment";
// import { useSelector } from "react-redux";
// import { LoadingPage } from "../../../common/LoadingPage";

// const DemoTypo = styled(Typography)(({ theme }) => ({
//     fontSize: 13
// }));

// const DemoTypography = styled(Typography)(({ theme }) => ({
//     color: '#1565c0',
//     fontSize: 13
// }));

// const Invoices = ({
//     projectData,
//     actionId,
//     items
// }) => {
//     const { user } = useSelector((state) => state.users);
//     const coverInputRef = useRef();
//     const currencySymbol = CurrencyJSON.find((curr) => curr.value === projectData?.currency)?.symbol || '';
//     const formatNumber = (num) => num ? Intl.NumberFormat('en-IN').format(num) : '0';
//     const [invoices, setInvoices] = useState([]);
//     const [dataLoading, setDataLoading] = useState(false);
//     const [rowsPerPage, setRowPerPage] = useState(10);
//     const [gridApi, setGridApi] = useState(null);
//     const [selectedData, setSelectedData] = useState(null);
//     const [dialogOpen, setDialogOpen] = useState(false);
//     const [invoiceId, setInvoiceId] = useState(null);
//     const [deleteOpen, setDeleteOpen] = useState(false);
//     const [invoiceObj, setInvoiceObj] = useState({
//         invoiceno: '',
//         status: InvoiceStatus[0]?.value,
//         invoicedate: null,
//         duedate: null,
//         itemtotal: '',
//         tax: '',
//         freight: '',
//         installation: '',
//         storage: '',
//         fees: '',
//         discounts: '',
//         tradein: '',
//         attachment: null
//     });

//     const getInvoiceData = async () => {
//         try {
//             const res = await apiRequest('get', `/po-invoice?purchaseModuleId=${actionId}`);
//             if (res?.data?.data) {
//                 setInvoices(res?.data?.data);
//             }
//             setDataLoading(false);
//         } catch (error) {
//             setDataLoading(false);
//             showNotification(error?.response?.data.error || error.message, 'error');
//         }
//     }

//     useEffect(() => {
//         getInvoiceData();
//     }, [actionId]);

//     const onPageSizeChanged = (event) => {
//         if (event.apiRequest) {
//             const newPageSize = event.api.paginationGetPageSize();
//             setRowPerPage(newPageSize);
//         }
//     };

//     const updatedColumns = useMemo(() => {
//         let column = InvoiceColumnDefs;
//         if (column.length > 0) {
//             return column?.map((col) => {
//                 switch (col.field) {
//                     case 'action':
//                         return {
//                             ...col,
//                             cellRenderer: (params) => params?.data?.invoice_no && (
//                                 <Box style={{ display: 'flex', alignItems: 'center' }}>
//                                     <EditOutlined
//                                         color="primary"
//                                         style={{ cursor: 'pointer', color: selectedData?.includes(params?.data?.po_invoice_id) ? '' : 'gray' }}
//                                         onClick={async () => {
//                                             if (selectedData?.includes(params?.data?.po_invoice_id)) {
//                                                 const response = await apiRequest('get', `/po-invoice/${params?.data?.po_invoice_id}`);
//                                                 console.log(response);
//                                                 const {
//                                                     freight, installation, storage, fees, tax, status,
//                                                     invoice_no, invoice_date, due_date, attachment, discounts, tradein, sub_total
//                                                 } = response.data.data;
//                                                 setInvoiceObj({
//                                                     invoiceno: invoice_no,
//                                                     status: status,
//                                                     invoicedate: invoice_date ? moment(invoice_date).format('YYYY-MM-DD') : null,
//                                                     duedate: due_date ? moment(due_date).format('YYYY-MM-DD') : null,
//                                                     itemtotal: sub_total,
//                                                     tax: tax,
//                                                     freight: freight,
//                                                     installation: installation,
//                                                     storage: storage,
//                                                     fees: fees,
//                                                     discounts: discounts,
//                                                     tradein: tradein,
//                                                     attachment: attachment
//                                                 });
//                                                 setInvoiceId(params?.data?.po_invoice_id);
//                                                 setDialogOpen(true);
//                                             }
//                                         }}
//                                     />
//                                     <DeleteOutline
//                                         color="secondary"
//                                         style={{ cursor: 'pointer', color: selectedData?.includes(params?.data?.po_invoice_id) ? '' : 'gray' }}
//                                         onClick={() => {
//                                             if (selectedData?.includes(params?.data?.po_invoice_id)) {
//                                                 setDeleteOpen(true);
//                                                 setInvoiceId(params?.data?.po_invoice_id);
//                                             }
//                                         }}
//                                     />
//                                 </Box>
//                             ),
//                         }
//                     case 'attachment': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.["attachment"]?.sortUrl) {
//                                         return (
//                                             <a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["attachment"]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer">
//                                                 <img src="/images/pdf.svg" alt="blog img" style={{ width: 16, margin: '3px 10px 10px 40px' }} />
//                                             </a>
//                                         );
//                                     }
//                                     return '';
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'status': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.status) {
//                                         return InvoiceStatus.find((a) => a.value === params?.data?.status)?.label
//                                     }
//                                     return '';
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'invoice_date': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.invoice_date) {
//                                         return moment(params?.data?.invoice_date).format('DD-MM-YYYY')
//                                     }
//                                     return '';
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'due_date': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.due_date) {
//                                         return moment(params?.data?.due_date).format('DD-MM-YYYY')
//                                     }
//                                     return '';
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'invoice_total': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 let total = 0;
//                                 if (params?.data?.sub_total) {
//                                     total += Number(params?.data?.sub_total)
//                                 }
//                                 if (params?.data?.tax) {
//                                     total += Number(params?.data?.tax)
//                                 }
//                                 if (params?.data?.freight) {
//                                     total += Number(params?.data?.freight)
//                                 }
//                                 if (params?.data?.installation) {
//                                     total += Number(params?.data?.installation)
//                                 }
//                                 if (params?.data?.storage) {
//                                     total += Number(params?.data?.storage)
//                                 }
//                                 if (params?.data?.fees) {
//                                     total += Number(params?.data?.fees)
//                                 }
//                                 if (params?.data?.discounts) {
//                                     total -= Number(params?.data?.discounts)
//                                 }
//                                 if (params?.data?.tradein) {
//                                     total -= Number(params?.data?.tradein)
//                                 }
//                                 return `${currencySymbol} ${formatNumber(total)}`;
//                             },
//                         };
//                     };
//                     case 'sub_total': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.sub_total) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.sub_total)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'freight': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.freight) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.freight)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'installation': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.installation) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.installation)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'storage': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.storage) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.storage)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'fees': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.fees) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.fees)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'discounts': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.discounts) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.discounts)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'tradein': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.tradein) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.tradein)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     case 'tax': {
//                         return {
//                             ...col,
//                             sortable: false,
//                             cellRenderer: (params) => {
//                                 if (params?.data) {
//                                     if (params?.data?.tax) {
//                                         return `${currencySymbol} ${formatNumber(params?.data?.tax)}`
//                                     }
//                                     return `${currencySymbol} 0`;
//                                 }
//                                 return '';
//                             },
//                         };
//                     };
//                     default:
//                         return col;
//                 }
//             });
//         }
//         return column;
//     }, [InvoiceColumnDefs, invoices, selectedData]);


//     const grandTotal = invoices
//         .filter(invoice => invoice.status !== 'cancelled')
//         .reduce((sum, invoice) => {
//             const sub_total = Number(invoice.sub_total) || 0;
//             const tax = Number(invoice.tax) || 0;
//             const freight = Number(invoice.freight) || 0;
//             const installation = Number(invoice.installation) || 0;
//             const fees = Number(invoice.fees) || 0;
//             const storage = Number(invoice.storage) || 0;
//             const discounts = Number(invoice.discounts) || 0;
//             const tradein = Number(invoice.tradein) || 0;

//             const invoiceTotal = sub_total + tax + freight + installation + fees + storage - discounts - tradein;
//             return sum + invoiceTotal;
//         }, 0);

//     const rowData = useMemo(() => {
//         return invoices
//             .filter(inv => inv.status !== 'cancelled')
//             .map(invoice => ({
//                 ...invoice,
//                 // Pre-calculate total for each row
//                 total: (Number(invoice.sub_total) || 0) +
//                     (Number(invoice.tax) || 0) +
//                     (Number(invoice.freight) || 0) +
//                     (Number(invoice.installation) || 0) +
//                     (Number(invoice.fees) || 0) +
//                     (Number(invoice.storage) || 0) -
//                     (Number(invoice.discounts) || 0) -
//                     (Number(invoice.tradein) || 0)
//             }));
//     }, [invoices]);

//     const pinnedBottomRowData = useMemo(() => {
//         if (rowData.length === 0) return [];

//         const totals = {
//             invoice_no: '', // Empty string instead of "Total"
//             invoice_date: '',
//             total: 0,
//             sub_total: 0,
//             tax: 0,
//             freight: 0,
//             storage: 0,
//             installation: 0,
//             fees: 0,
//             discounts: 0,
//             tradein: 0,
//             attachment: '' // Empty for attachment column
//         };

//         rowData.forEach(row => {
//             totals.total += row.total || 0;
//             totals.sub_total += Number(row.sub_total) || 0;
//             totals.tax += Number(row.tax) || 0;
//             totals.freight += Number(row.freight) || 0;
//             totals.storage += Number(row.storage) || 0;
//             totals.installation += Number(row.installation) || 0;
//             totals.fees += Number(row.fees) || 0;
//             totals.discounts += Number(row.discounts) || 0;
//             totals.tradein += Number(row.tradein) || 0;
//         });

//         return [totals];
//     }, [rowData]);


//     return (
//         <>
//             <Dialog
//                 open={deleteOpen}
//                 fullWidth
//                 maxWidth="sm"
//             >
//                 <DialogContent>
//                     <Typography>Are you sure you want to permanently delete this one? It cannot be recovered</Typography>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button
//                         color="primary"
//                         size="Medium"
//                         variant="contained"
//                         onClick={async () => {
//                             try {
//                                 setDataLoading(true);
//                                 const response = await apiRequest('delete', `/po-invoice/${invoiceId}`);
//                                 if (response.data) {
//                                     setDeleteOpen(false);
//                                     showNotification(`Invoice Deleted Successfully`, 'success');
//                                     getInvoiceData();
//                                     setInvoiceId(null);
//                                     setDataLoading(false);
//                                 }
//                             } catch (error) {
//                                 setDataLoading(false);
//                                 showNotification(error?.response?.data.error || error.message, 'error');
//                             }
//                         }}
//                     >
//                         Yes
//                     </Button>
//                     <Button
//                         color="secondary"
//                         size="Medium"
//                         variant="contained"
//                         onClick={() => {
//                             setDeleteOpen(false);
//                             setInvoiceId(null);
//                         }}
//                     >
//                         No
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             <Dialog
//                 open={dialogOpen}
//                 maxWidth="md"
//                 fullWidth
//             >
//                 <DialogTitle>{`${invoiceId !== null ? 'Edit' : 'Add'} Invoice`}</DialogTitle>
//                 <DialogContent>
//                     <Grid container spacing={2} mt={1}>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Invoice # *"
//                                 id="invoiceno"
//                                 type="text"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.invoiceno || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         invoiceno: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.invoiceno !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <Autocomplete
//                                 value={InvoiceStatus.find((c) => c.value === invoiceObj.status) || null}
//                                 id="combo-box-demo"
//                                 size="small"
//                                 fullWidth
//                                 options={InvoiceStatus}
//                                 clearIcon={null}
//                                 getOptionLabel={(a) => a.label}
//                                 onChange={async (event, newValue) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         status: newValue?.value
//                                     }))
//                                 }}
//                                 renderInput={(params) =>
//                                     <TextField
//                                         fullWidth
//                                         {...params}
//                                         label="Status"
//                                         name="Status"
//                                         variant="outlined"
//                                         InputProps={{
//                                             ...params.InputProps,
//                                             endAdornment: (
//                                                 <>
//                                                     {params.InputProps.endAdornment}
//                                                 </>
//                                             ),
//                                         }}
//                                     />}
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Invoice Date"
//                                 id="invoice-date"
//                                 type="date"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.invoicedate || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         invoicedate: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.invoicedate !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Due Date"
//                                 id="duedate-date"
//                                 type="date"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.duedate || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         duedate: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.duedate !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Item Total"
//                                 id="itemtotal"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.itemtotal || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         itemtotal: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.itemtotal !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Tax"
//                                 id="tax"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.tax || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         tax: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.tax !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Freight"
//                                 id="freight"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.freight || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         freight: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.freight !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Storage"
//                                 id="storage"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.storage || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         storage: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.storage !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Installation"
//                                 id="installation"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.installation || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         installation: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.installation !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Fees"
//                                 id="fees"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.fees || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         fees: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.fees !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Discounts"
//                                 id="discounts"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.discounts || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         discounts: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.discounts !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <TextField
//                                 label="Trade In"
//                                 id="tradein"
//                                 type="number"
//                                 fullWidth
//                                 size="small"
//                                 value={invoiceObj?.tradein || ''}
//                                 onChange={(e) => {
//                                     setInvoiceObj((prevData) => ({
//                                         ...prevData,
//                                         tradein: e.target.value || null,
//                                     }));
//                                 }}
//                                 InputLabelProps={{
//                                     shrink: invoiceObj?.tradein !== '', // Shrink label when input is filled
//                                 }}
//                                 inputProps={{
//                                     style: { padding: '10px' }, // Adjust padding and height if needed
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <Typography variant="body1">
//                                 {invoiceObj?.attachment?.fileName ? invoiceObj?.attachment?.fileName : invoiceObj?.attachment?.name}
//                                 {(invoiceObj?.attachment?.name || invoiceObj?.attachment?.fileName) && (
//                                     <IconButton color="secondary" onClick={() => {
//                                         setInvoiceObj((prevData) => ({
//                                             ...prevData,
//                                             attachment: null
//                                         }))
//                                         if (coverInputRef.current) {
//                                             coverInputRef.current.value = ''; // Reset the file input field
//                                         }
//                                     }}>
//                                         <Close />
//                                     </IconButton>
//                                 )}
//                             </Typography>
//                             <Button
//                                 variant="contained"
//                                 component="label"
//                                 startIcon={<Upload />}
//                             >
//                                 Upload
//                                 <input
//                                     type="file"
//                                     hidden
//                                     accept=".pdf"
//                                     ref={coverInputRef}
//                                     onChange={(e) => {
//                                         setInvoiceObj((prevData) => ({
//                                             ...prevData,
//                                             attachment: e.target.files[0]
//                                         }))
//                                     }}
//                                 />
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button
//                         variant="outlined"
//                         color="secondary"
//                         size="small"
//                         onClick={() => {
//                             setDialogOpen(false);
//                             setInvoiceObj({
//                                 invoiceno: '',
//                                 status: InvoiceStatus[0]?.value,
//                                 invoicedate: null,
//                                 duedate: null,
//                                 itemtotal: '',
//                                 tax: '',
//                                 freight: '',
//                                 installation: '',
//                                 storage: '',
//                                 fees: '',
//                                 discounts: '',
//                                 tradein: '',
//                                 attachment: null
//                             });
//                             setInvoiceId(null);
//                         }}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="contained"
//                         color="primary"
//                         size="small"
//                         onClick={async () => {
//                             if (invoiceObj.invoiceno !== '') {
//                                 try {
//                                     setDataLoading(true);
//                                     let response;
//                                     const formData = new FormData();
//                                     appendIfNotNull(formData, 'organization_id', user.organization.organization_id);
//                                     appendIfNotNull(formData, 'project_id', projectData.project_id);
//                                     appendIfNotNull(formData, 'purchase_module_id', actionId);
//                                     appendIfNotNull(formData, 'invoice_no', invoiceObj.invoiceno);
//                                     appendIfNotNull(formData, 'status', invoiceObj.status);
//                                     appendIfNotNull(formData, 'invoice_date', invoiceObj?.invoicedate !== 'Invalid date' && invoiceObj?.invoicedate !== null ? moment(invoiceObj?.invoicedate).format('YYYY-MM-DDThh:mm:ssZ') : null);
//                                     appendIfNotNull(formData, 'due_date', invoiceObj?.duedate !== 'Invalid date' && invoiceObj?.duedate !== null ? moment(invoiceObj?.duedate).format('YYYY-MM-DDThh:mm:ssZ') : null);
//                                     appendIfNotNull(formData, 'sub_total', invoiceObj.itemtotal);
//                                     appendIfNotNull(formData, 'tax', invoiceObj.tax);
//                                     appendIfNotNull(formData, 'freight', invoiceObj.freight);
//                                     appendIfNotNull(formData, 'installation', invoiceObj.installation);
//                                     appendIfNotNull(formData, 'storage', invoiceObj.storage);
//                                     appendIfNotNull(formData, 'fees', invoiceObj.fees);
//                                     appendIfNotNull(formData, 'discounts', invoiceObj.discounts);
//                                     appendIfNotNull(formData, 'tradein', invoiceObj.tradein);
//                                     formData.append('attachment_file', invoiceObj.attachment);
//                                     if (invoiceId) {
//                                         response = await apiRequest('put', `/po-invoice/${invoiceId}`, formData);
//                                     } else {
//                                         response = await apiRequest('post', `/po-invoice`, formData);
//                                     }
//                                     if (response.data.data) {
//                                         showNotification(`${invoiceId ? 'Invoice updated Successfully' : 'Invoice Created Successfully'}`, 'success');
//                                         setInvoiceObj({
//                                             invoiceno: '',
//                                             status: InvoiceStatus[0]?.value,
//                                             invoicedate: null,
//                                             duedate: null,
//                                             itemtotal: '',
//                                             tax: '',
//                                             freight: '',
//                                             installation: '',
//                                             storage: '',
//                                             fees: '',
//                                             discounts: '',
//                                             tradein: '',
//                                             attachment: null
//                                         });
//                                         setInvoiceId(null);
//                                         getInvoiceData();
//                                     }
//                                     setDataLoading(false);
//                                     setDialogOpen(false);
//                                 } catch (error) {
//                                     setDataLoading(false);
//                                     showNotification(error?.response?.data.error || error.message, 'error');
//                                 }
//                             } else {
//                                 showNotification('Please provide invoice #', 'error');
//                             }
//                         }}
//                     >
//                         Save
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
//             <Grid container spacing={2} mt={0.1}>
//                 <Grid item xs={12} md={3}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                         <DemoTypography variant="body2">PO Total :</DemoTypography>
//                         <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(items.reduce((sum, item) => sum + item.totalCost, 0))}`}</DemoTypo>
//                     </Box>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                         <DemoTypography variant="body2">Paid Amount :</DemoTypography>
//                         <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(grandTotal)}`}</DemoTypo>
//                     </Box>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                         <DemoTypography variant="body2">Payment Balance :</DemoTypography>
//                         <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(Number(items.reduce((sum, item) => sum + item.totalCost, 0)) - parseInt(grandTotal, 10))}`}</DemoTypo>
//                     </Box>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                     <Button
//                         variant="contained"
//                         size="Medium"
//                         color="primary"
//                         style={{ float: 'right' }}
//                         onClick={() => setDialogOpen(true)}
//                         startIcon={<Add />}
//                     >
//                         Create
//                     </Button>
//                 </Grid>
//             </Grid>
//             <DataTable
//                 height="55vh"
//                 columnDefs={updatedColumns}
//                 rowData={rowData}
//                 rowsPerPage={rowsPerPage}
//                 paginationPageSizeSelector={[10, 15, 25, 50, 100]}
//                 onPaginationChanged={onPageSizeChanged}
//                 modelType="clientSide"
//                 onGridReady={(params) => {
//                     setGridApi(params.api)
//                 }}
//                 pinnedBottomRowData={pinnedBottomRowData}
//                 onSelectionChanged={() => {
//                     if (gridApi) {
//                         const selectedNodes = gridApi.getSelectedNodes();
//                         setSelectedData(selectedNodes.map((node) => node.data.po_invoice_id));
//                     }
//                 }}
//             />
//         </>
//     )
// }

// export default Invoices;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, styled, TextField, Typography } from "@mui/material";
import { appendIfNotNull, CurrencyJSON, InvoiceStatus } from "../../../common/const";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../common/common";
import DataTable from "../../../common/DataTable";
import { Add, Close, DeleteOutline, EditOutlined, Upload } from "@mui/icons-material";
import { InvoiceColumnDefs } from "./columnDefs";
import moment from "moment";
import { useSelector } from "react-redux";
import { LoadingPage } from "../../../common/LoadingPage";

const DemoTypo = styled(Typography)(({ theme }) => ({ fontSize: 13 }));
const DemoTypography = styled(Typography)(({ theme }) => ({ color: '#1565c0', fontSize: 13 }));

const Invoices = ({ projectData, actionId, items }) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const isGuestUser = isUser?.code === 'orgGuestUser';

    const coverInputRef = useRef();
    const currencySymbol = CurrencyJSON.find((curr) => curr.value === projectData?.currency)?.symbol || '';
    const formatNumber = (num) => num ? Intl.NumberFormat('en-IN').format(num) : '0';
    const [invoices, setInvoices] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [rowsPerPage, setRowPerPage] = useState(10);
    const [gridApi, setGridApi] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [invoiceId, setInvoiceId] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [invoiceObj, setInvoiceObj] = useState({
        invoiceno: '', status: InvoiceStatus[0]?.value, invoicedate: null, duedate: null,
        itemtotal: '', tax: '', freight: '', installation: '', storage: '',
        fees: '', discounts: '', tradein: '', attachment: null
    });

    const getInvoiceData = async () => {
        try {
            const res = await apiRequest('get', `/po-invoice?purchaseModuleId=${actionId}`);
            if (res?.data?.data) setInvoices(res?.data?.data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    };

    useEffect(() => { getInvoiceData(); }, [actionId]);

    const onPageSizeChanged = (event) => {
        if (event.apiRequest) {
            const newPageSize = event.api.paginationGetPageSize();
            setRowPerPage(newPageSize);
        }
    };

    const updatedColumns = useMemo(() => {
        let column = InvoiceColumnDefs;
        if (column.length > 0) {
            return column?.map((col) => {
                switch (col.field) {
                    case 'action':
                        return {
                            ...col,
                            cellRenderer: (params) => params?.data?.invoice_no && (
                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* Edit icon — hidden for guest */}
                                    {!isGuestUser && (
                                        <EditOutlined color="primary"
                                            style={{ cursor: 'pointer', color: selectedData?.includes(params?.data?.po_invoice_id) ? '' : 'gray' }}
                                            onClick={async () => {
                                                if (selectedData?.includes(params?.data?.po_invoice_id)) {
                                                    const response = await apiRequest('get', `/po-invoice/${params?.data?.po_invoice_id}`);
                                                    const { freight, installation, storage, fees, tax, status, invoice_no, invoice_date, due_date, attachment, discounts, tradein, sub_total } = response.data.data;
                                                    setInvoiceObj({ invoiceno: invoice_no, status, invoicedate: invoice_date ? moment(invoice_date).format('YYYY-MM-DD') : null, duedate: due_date ? moment(due_date).format('YYYY-MM-DD') : null, itemtotal: sub_total, tax, freight, installation, storage, fees, discounts, tradein, attachment });
                                                    setInvoiceId(params?.data?.po_invoice_id);
                                                    setDialogOpen(true);
                                                }
                                            }} />
                                    )}
                                    {/* Delete icon — hidden for guest */}
                                    {!isGuestUser && (
                                        <DeleteOutline color="secondary"
                                            style={{ cursor: 'pointer', color: selectedData?.includes(params?.data?.po_invoice_id) ? '' : 'gray' }}
                                            onClick={() => {
                                                if (selectedData?.includes(params?.data?.po_invoice_id)) {
                                                    setDeleteOpen(true);
                                                    setInvoiceId(params?.data?.po_invoice_id);
                                                }
                                            }} />
                                    )}
                                </Box>
                            ),
                        };
                    case 'attachment':
                        return {
                            ...col, sortable: false,
                            cellRenderer: (params) => {
                                if (params?.data?.["attachment"]?.sortUrl) {
                                    return (<a href={`${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.["attachment"]?.sortUrl}}&uid=${user?.user_id}`} target="_blank" rel="noreferrer"><img src="/images/pdf.svg" alt="pdf" style={{ width: 16, margin: '3px 10px 10px 40px' }} /></a>);
                                }
                                return '';
                            },
                        };
                    case 'status':
                        return { ...col, sortable: false, cellRenderer: (params) => params?.data?.status ? InvoiceStatus.find((a) => a.value === params?.data?.status)?.label : '' };
                    case 'invoice_date':
                        return { ...col, sortable: false, cellRenderer: (params) => params?.data?.invoice_date ? moment(params?.data?.invoice_date).format('DD-MM-YYYY') : '' };
                    case 'due_date':
                        return { ...col, sortable: false, cellRenderer: (params) => params?.data?.due_date ? moment(params?.data?.due_date).format('DD-MM-YYYY') : '' };
                    case 'invoice_total':
                        return {
                            ...col, sortable: false,
                            cellRenderer: (params) => {
                                let total = (Number(params?.data?.sub_total) || 0) + (Number(params?.data?.tax) || 0) + (Number(params?.data?.freight) || 0) + (Number(params?.data?.installation) || 0) + (Number(params?.data?.storage) || 0) + (Number(params?.data?.fees) || 0) - (Number(params?.data?.discounts) || 0) - (Number(params?.data?.tradein) || 0);
                                return `${currencySymbol} ${formatNumber(total)}`;
                            },
                        };
                    case 'sub_total': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.sub_total ? `${currencySymbol} ${formatNumber(params?.data?.sub_total)}` : `${currencySymbol} 0` };
                    case 'freight': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.freight ? `${currencySymbol} ${formatNumber(params?.data?.freight)}` : `${currencySymbol} 0` };
                    case 'installation': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.installation ? `${currencySymbol} ${formatNumber(params?.data?.installation)}` : `${currencySymbol} 0` };
                    case 'storage': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.storage ? `${currencySymbol} ${formatNumber(params?.data?.storage)}` : `${currencySymbol} 0` };
                    case 'fees': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.fees ? `${currencySymbol} ${formatNumber(params?.data?.fees)}` : `${currencySymbol} 0` };
                    case 'discounts': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.discounts ? `${currencySymbol} ${formatNumber(params?.data?.discounts)}` : `${currencySymbol} 0` };
                    case 'tradein': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.tradein ? `${currencySymbol} ${formatNumber(params?.data?.tradein)}` : `${currencySymbol} 0` };
                    case 'tax': return { ...col, sortable: false, cellRenderer: (params) => params?.data?.tax ? `${currencySymbol} ${formatNumber(params?.data?.tax)}` : `${currencySymbol} 0` };
                    default: return col;
                }
            });
        }
        return column;
    }, [InvoiceColumnDefs, invoices, selectedData, isGuestUser]);

    const grandTotal = invoices
        .filter(invoice => invoice.status !== 'cancelled')
        .reduce((sum, invoice) => {
            return sum + (Number(invoice.sub_total) || 0) + (Number(invoice.tax) || 0) + (Number(invoice.freight) || 0) + (Number(invoice.installation) || 0) + (Number(invoice.fees) || 0) + (Number(invoice.storage) || 0) - (Number(invoice.discounts) || 0) - (Number(invoice.tradein) || 0);
        }, 0);

    const rowData = useMemo(() => {
        return invoices.filter(inv => inv.status !== 'cancelled').map(invoice => ({
            ...invoice,
            total: (Number(invoice.sub_total) || 0) + (Number(invoice.tax) || 0) + (Number(invoice.freight) || 0) + (Number(invoice.installation) || 0) + (Number(invoice.fees) || 0) + (Number(invoice.storage) || 0) - (Number(invoice.discounts) || 0) - (Number(invoice.tradein) || 0)
        }));
    }, [invoices]);

    const pinnedBottomRowData = useMemo(() => {
        if (rowData.length === 0) return [];
        const totals = { invoice_no: '', invoice_date: '', total: 0, sub_total: 0, tax: 0, freight: 0, storage: 0, installation: 0, fees: 0, discounts: 0, tradein: 0, attachment: '' };
        rowData.forEach(row => {
            totals.total += row.total || 0; totals.sub_total += Number(row.sub_total) || 0; totals.tax += Number(row.tax) || 0;
            totals.freight += Number(row.freight) || 0; totals.storage += Number(row.storage) || 0;
            totals.installation += Number(row.installation) || 0; totals.fees += Number(row.fees) || 0;
            totals.discounts += Number(row.discounts) || 0; totals.tradein += Number(row.tradein) || 0;
        });
        return [totals];
    }, [rowData]);

    const resetInvoiceObj = () => setInvoiceObj({ invoiceno: '', status: InvoiceStatus[0]?.value, invoicedate: null, duedate: null, itemtotal: '', tax: '', freight: '', installation: '', storage: '', fees: '', discounts: '', tradein: '', attachment: null });

    return (
        <>
            {/* ── Delete confirm — hidden for guest ── */}
            {!isGuestUser && (
                <Dialog open={deleteOpen} fullWidth maxWidth="sm">
                    <DialogContent><Typography>Are you sure you want to permanently delete this one? It cannot be recovered</Typography></DialogContent>
                    <DialogActions>
                        <Button color="primary" size="Medium" variant="contained" onClick={async () => {
                            try {
                                setDataLoading(true);
                                const response = await apiRequest('delete', `/po-invoice/${invoiceId}`);
                                if (response.data) { setDeleteOpen(false); showNotification(`Invoice Deleted Successfully`, 'success'); getInvoiceData(); setInvoiceId(null); setDataLoading(false); }
                            } catch (error) { setDataLoading(false); showNotification(error?.response?.data.error || error.message, 'error'); }
                        }}>Yes</Button>
                        <Button color="secondary" size="Medium" variant="contained" onClick={() => { setDeleteOpen(false); setInvoiceId(null); }}>No</Button>
                    </DialogActions>
                </Dialog>
            )}

            {/* ── Add/Edit Invoice dialog — hidden for guest ── */}
            {!isGuestUser && (
                <Dialog open={dialogOpen} maxWidth="md" fullWidth>
                    <DialogTitle>{`${invoiceId !== null ? 'Edit' : 'Add'} Invoice`}</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} md={6}><TextField label="Invoice # *" type="text" fullWidth size="small" value={invoiceObj?.invoiceno || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, invoiceno: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.invoiceno !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}>
                                <Autocomplete value={InvoiceStatus.find((c) => c.value === invoiceObj.status) || null} size="small" fullWidth options={InvoiceStatus} clearIcon={null} getOptionLabel={(a) => a.label}
                                    onChange={(event, newValue) => setInvoiceObj((p) => ({ ...p, status: newValue?.value }))}
                                    renderInput={(params) => <TextField fullWidth {...params} label="Status" name="Status" variant="outlined" />} />
                            </Grid>
                            <Grid item xs={12} md={6}><TextField label="Invoice Date" type="date" fullWidth size="small" value={invoiceObj?.invoicedate || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, invoicedate: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.invoicedate !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Due Date" type="date" fullWidth size="small" value={invoiceObj?.duedate || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, duedate: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.duedate !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Item Total" type="number" fullWidth size="small" value={invoiceObj?.itemtotal || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, itemtotal: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.itemtotal !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Tax" type="number" fullWidth size="small" value={invoiceObj?.tax || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, tax: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.tax !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Freight" type="number" fullWidth size="small" value={invoiceObj?.freight || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, freight: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.freight !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Storage" type="number" fullWidth size="small" value={invoiceObj?.storage || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, storage: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.storage !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Installation" type="number" fullWidth size="small" value={invoiceObj?.installation || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, installation: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.installation !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Fees" type="number" fullWidth size="small" value={invoiceObj?.fees || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, fees: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.fees !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Discounts" type="number" fullWidth size="small" value={invoiceObj?.discounts || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, discounts: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.discounts !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}><TextField label="Trade In" type="number" fullWidth size="small" value={invoiceObj?.tradein || ''} onChange={(e) => setInvoiceObj((p) => ({ ...p, tradein: e.target.value || null }))} InputLabelProps={{ shrink: invoiceObj?.tradein !== '' }} inputProps={{ style: { padding: '10px' } }} variant="outlined" /></Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body1">
                                    {invoiceObj?.attachment?.fileName ? invoiceObj?.attachment?.fileName : invoiceObj?.attachment?.name}
                                    {(invoiceObj?.attachment?.name || invoiceObj?.attachment?.fileName) && (
                                        <IconButton color="secondary" onClick={() => { setInvoiceObj((p) => ({ ...p, attachment: null })); if (coverInputRef.current) coverInputRef.current.value = ''; }}><Close /></IconButton>
                                    )}
                                </Typography>
                                <Button variant="contained" component="label" startIcon={<Upload />}>
                                    Upload
                                    <input type="file" hidden accept=".pdf" ref={coverInputRef} onChange={(e) => setInvoiceObj((p) => ({ ...p, attachment: e.target.files[0] }))} />
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="secondary" size="small" onClick={() => { setDialogOpen(false); resetInvoiceObj(); setInvoiceId(null); }}>Cancel</Button>
                        <Button variant="contained" color="primary" size="small" onClick={async () => {
                            if (invoiceObj.invoiceno !== '') {
                                try {
                                    setDataLoading(true);
                                    let response;
                                    const formData = new FormData();
                                    appendIfNotNull(formData, 'organization_id', user.organization.organization_id);
                                    appendIfNotNull(formData, 'project_id', projectData.project_id);
                                    appendIfNotNull(formData, 'purchase_module_id', actionId);
                                    appendIfNotNull(formData, 'invoice_no', invoiceObj.invoiceno);
                                    appendIfNotNull(formData, 'status', invoiceObj.status);
                                    appendIfNotNull(formData, 'invoice_date', invoiceObj?.invoicedate !== 'Invalid date' && invoiceObj?.invoicedate !== null ? moment(invoiceObj?.invoicedate).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                    appendIfNotNull(formData, 'due_date', invoiceObj?.duedate !== 'Invalid date' && invoiceObj?.duedate !== null ? moment(invoiceObj?.duedate).format('YYYY-MM-DDThh:mm:ssZ') : null);
                                    appendIfNotNull(formData, 'sub_total', invoiceObj.itemtotal);
                                    appendIfNotNull(formData, 'tax', invoiceObj.tax);
                                    appendIfNotNull(formData, 'freight', invoiceObj.freight);
                                    appendIfNotNull(formData, 'installation', invoiceObj.installation);
                                    appendIfNotNull(formData, 'storage', invoiceObj.storage);
                                    appendIfNotNull(formData, 'fees', invoiceObj.fees);
                                    appendIfNotNull(formData, 'discounts', invoiceObj.discounts);
                                    appendIfNotNull(formData, 'tradein', invoiceObj.tradein);
                                    formData.append('attachment_file', invoiceObj.attachment);
                                    if (invoiceId) { response = await apiRequest('put', `/po-invoice/${invoiceId}`, formData); }
                                    else { response = await apiRequest('post', `/po-invoice`, formData); }
                                    if (response.data.data) {
                                        showNotification(`${invoiceId ? 'Invoice updated Successfully' : 'Invoice Created Successfully'}`, 'success');
                                        resetInvoiceObj(); setInvoiceId(null); getInvoiceData();
                                    }
                                    setDataLoading(false); setDialogOpen(false);
                                } catch (error) { setDataLoading(false); showNotification(error?.response?.data.error || error.message, 'error'); }
                            } else { showNotification('Please provide invoice #', 'error'); }
                        }}>Save</Button>
                    </DialogActions>
                </Dialog>
            )}

            {dataLoading && <LoadingPage isLoading={dataLoading} />}

            <Grid container spacing={2} mt={0.1}>
                <Grid item xs={12} md={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">PO Total :</DemoTypography>
                        <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(items.reduce((sum, item) => sum + item.totalCost, 0))}`}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Paid Amount :</DemoTypography>
                        <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(grandTotal)}`}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Payment Balance :</DemoTypography>
                        <DemoTypo variant="body2">{`${currencySymbol} ${formatNumber(Number(items.reduce((sum, item) => sum + item.totalCost, 0)) - parseInt(grandTotal, 10))}`}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                    {/* Create button — hidden for guest */}
                    {!isGuestUser && (
                        <Button variant="contained" size="Medium" color="primary" style={{ float: 'right' }}
                            onClick={() => setDialogOpen(true)} startIcon={<Add />}>
                            Create
                        </Button>
                    )}
                </Grid>
            </Grid>

            <DataTable
                height="55vh"
                columnDefs={updatedColumns}
                rowData={rowData}
                rowsPerPage={rowsPerPage}
                paginationPageSizeSelector={[10, 15, 25, 50, 100]}
                onPaginationChanged={onPageSizeChanged}
                modelType="clientSide"
                onGridReady={(params) => setGridApi(params.api)}
                pinnedBottomRowData={pinnedBottomRowData}
                onSelectionChanged={() => {
                    if (gridApi) {
                        const selectedNodes = gridApi.getSelectedNodes();
                        setSelectedData(selectedNodes.map((node) => node.data.po_invoice_id));
                    }
                }}
            />
        </>
    );
};

export default Invoices;